import React from 'react';
import { useDiary, pixelY } from './DiaryContext';

/**
 * Grey, striped, opaque blocks for a shared team member's bookings at ANOTHER
 * location (spec §14 M2). Site name and time only — no client, no service —
 * and nothing is clickable: writes never cross sites.
 */
export default function OtherSiteBlocks({ staff }) {
    const { state } = useDiary();
    const { viewStartMinutes, zoomLevel, otherSiteBlocks, selectedDate } = state;
    const blocks = (otherSiteBlocks && otherSiteBlocks[String(staff && staff.id)]) || [];
    if (!blocks.length) return null;
    return blocks.filter(b => !selectedDate || (b.date === selectedDate)).map((b, i) => {
        const top = pixelY(b.startMinutes, viewStartMinutes, zoomLevel);
        const height = Math.max(18, pixelY(b.endMinutes - b.startMinutes, 0, zoomLevel));
        return (
            <div key={i} className="dv2-other-site-block" style={{ top, height }} title={`Booked at ${b.salonName}`}>
                <strong>At {b.salonName}</strong>
            </div>
        );
    });
}
